var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVaults(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 14.0625H5.0625M9.5625 14.0625H11.8125M11.4375 3.1875V9.1875M0.5625 2.9625L0.5625 9.4125C0.5625 10.2526 0.5625 10.6726 0.72599 10.9935C0.8698 11.2757 1.09927 11.5052 1.38151 11.649C1.70238 11.8125 2.12242 11.8125 2.9625 11.8125L11.6625 11.8125C12.5026 11.8125 12.9226 11.8125 13.2435 11.649C13.5257 11.5052 13.7552 11.2757 13.899 10.9935C14.0625 10.6726 14.0625 10.2526 14.0625 9.4125V2.9625C14.0625 2.12242 14.0625 1.70238 13.899 1.38152C13.7552 1.09927 13.5257 0.869801 13.2435 0.725991C12.9226 0.562501 12.5026 0.562501 11.6625 0.562501L2.9625 0.5625C2.12242 0.5625 1.70238 0.5625 1.38151 0.72599C1.09927 0.8698 0.8698 1.09927 0.72599 1.38151C0.5625 1.70238 0.5625 2.12242 0.5625 2.9625ZM6.9375 6.1875C6.9375 7.22303 6.09803 8.0625 5.0625 8.0625C4.02697 8.0625 3.1875 7.22303 3.1875 6.1875C3.1875 5.15197 4.02697 4.3125 5.0625 4.3125C6.09803 4.3125 6.9375 5.15197 6.9375 6.1875Z",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaults);
export default __webpack_public_path__ + "static/media/vaults.e724f20bf84ee761bc8438bcbecee530.svg";
export { ForwardRef as ReactComponent };